import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { Icons } from '../../image'
import { AccordionSection, AccordionCard } from '../../accordion'
import { LeaseTerm, Tabs } from '@mmsg/louie'
import ContactUsDialog from '../../dialog/contactUsDialog'
import { useSelector } from 'react-redux'
import Tooltip from '../../tooltip'
import {
  capitalizeOnlyFirstLetter,
  capitalizeEachFirstLetter,
  toLowerCase,
  formatCurrency,
  IsSpecialEmployer,
  useWindowSize,
  payFrequencyToPaysPA,
} from 'application/helpers'
import { getCurrentResolutionBreakPoint } from 'application/utils/utilityFunctions'

import { applicationRoles } from 'application/constants/actionTypes'
import { PrimaryButton } from '@mmsg/louie'
import * as E from './runningSectionElements'
import * as S from './estimateDetailElements'
import { EstimateDetailStaticData } from './estimateDetailStaticData'
import { Icon as MaxxiaIcon } from 'Maxxia/icons'
import { Icon as RemServIcon } from 'RemServ/icons'
import { theme as MaxxiaTheme } from 'Maxxia/theme'
import { theme as RemServTheme } from 'RemServ/theme'

const TakeHomePayTable = ({
  grossSalary,
  preTaxDeduction,
  taxShare,
  otherPreTax,
  netSalary,
  taxMedicare,
  netIncome,
  postTax,
  otherPostTax,
  takeHome,
  fbt,
  fbtMethod,
  overTheCapMethod,
  isNSWHN,
}) => {
  let GetFBTMethodText = () => {
    if (
      fbtMethod &&
      overTheCapMethod &&
      postTax &&
      fbtMethod.toLowerCase() == 'ecm' &&
      overTheCapMethod.toLowerCase().includes('cap') &&
      postTax == 0
    ) {
      return 'Using your CAP'
    } else if (
      fbtMethod &&
      overTheCapMethod &&
      postTax &&
      fbtMethod.toLowerCase() == 'ecm' &&
      overTheCapMethod.toLowerCase().includes('cap') &&
      postTax > 0
    ) {
      return 'Using your CAP and ECM'
    } else if (fbtMethod && fbtMethod.toLowerCase().includes('cap')) {
      return postTax > 0 ? 'Using your CAP and ECM' : 'Using your CAP'
    } else {
      return fbtMethod
    }
  }

  let fbtText = GetFBTMethodText()

  return (
    <>
      {isNSWHN && (
        <Row className="mx-0 mr-md-3">
          <Col xs={12} md={2} className="text-header px-0">
            FBT Method
          </Col>
          <Col xs={6} md={5} className="px-0">
            {fbtText}
          </Col>
        </Row>
      )}
      <Row className="mx-0 mr-md-3">
        <S.CardText xs={12} md={2} bold className="px-0">
          PRE-TAX
        </S.CardText>
        <Col xs={6} md={5} className="px-0">
          <div className="d-flex ">
            {global.config.isBrandMX && (
              <>
                <span className="mr-2">Gross income </span>
                <Tooltip
                  header="Gross income"
                  text="The total income you earn before PAYG (income tax), minus your superannuation or any other deductions. Think salaries, and even bonuses."
                  id="summarysection.grossincometooltip"
                />
              </>
            )}
            {global.config.isBrandRS && (
              <S.BrandDefaultText className="mr-2">
                <Tooltip
                  header="Gross"
                  headerText="Gross income"
                  launchViaTitleText={true}
                  text="The total income you earn before PAYG (income tax), minus your superannuation or any other deductions. Think salaries, and even bonuses."
                  id="summarysection.grossincometooltip"
                />{' '}
                income
              </S.BrandDefaultText>
            )}
          </div>
        </Col>
        <S.CardValue
          xs={6}
          md={5}
          className="px-0"
          id="summarysection.grossincome"
        >
          {formatCurrency(grossSalary)}
        </S.CardValue>
      </Row>

      <Row className="mx-0 mr-md-3">
        <Col xs={8} md={{ offset: 2 }} className="px-0">
          {global.config.isBrandMX && (
            <>
              <span className="mr-2">Pre-tax novated lease deduction</span>

              <Tooltip
                header="Pre-tax novated lease deduction"
                text="The portion of your lease deductions taken before you’ve been taxed. This deduction lowers your overall taxable income, which means you could pay less tax."
                id="summarysection.pretaxnldeductiontooltip"
              />
            </>
          )}
          {global.config.isBrandRS && (
            <S.BrandDefaultText>
              <Tooltip
                header="Pre-tax"
                headerText="Pre-tax novated lease deduction"
                text="The portion of your lease deductions taken before you’ve been taxed. This deduction lowers your overall taxable income, which means you could pay less tax."
                launchViaTitleText={true}
                id="summarysection.pretaxnldeductiontooltip"
              />{' '}
              novated lease deduction
            </S.BrandDefaultText>
          )}
        </Col>
        <S.CardValue
          xs={4}
          className="text-right px-0"
          id="summarysection.pretaxnldeduction"
        >
          {formatCurrency(preTaxDeduction)}
        </S.CardValue>
      </Row>

      {taxShare > 0 && (
        <Row className="mx-0 mr-md-3">
          <Col xs={8} md={{ offset: 2 }} className="px-0">
            <S.BrandDefaultText>Tax share deduction</S.BrandDefaultText>
          </Col>
          <S.CardValue
            xs={4}
            className="px-0"
            id="summarysection.taxsharededuction"
          >
            {formatCurrency(taxShare)}
          </S.CardValue>
        </Row>
      )}

      {otherPreTax > 0 && (
        <Row className="mx-0 mr-md-3">
          <S.CardText xs={8} md={{ offset: 2 }} className="px-0">
            Other salary packaging (Pre-tax)
          </S.CardText>
          <S.CardValue
            xs={4}
            className="px-0"
            id="summarysection.othersppretax"
          >
            {formatCurrency(otherPreTax)}
          </S.CardValue>
        </Row>
      )}

      <Row className="mx-0 mr-md-3">
        <S.CardText xs={8} md={{ offset: 2 }} className="pt-2 px-0 border-top">
          <div
            style={{
              fontWeight: global.config.brand === 'Maxxia' ? '700' : '400',
            }}
          >
            Resulting taxable income
          </div>
        </S.CardText>
        <S.CardValue
          xs={4}
          className="pt-2 px-0 border-top"
          id="summarysection.taxableincome"
          bold={global.config.brand === 'Maxxia'}
        >
          {formatCurrency(netSalary)}
        </S.CardValue>
      </Row>

      <div className="bg-light pb-2 pt-3 mt-3 ">
        {fbt > 0 && (
          <Row className="mx-0 mr-md-3">
            <S.CardText xs={8} md={{ offset: 2 }} className="px-0">
              <Tooltip
                header="FBT"
                headerText={global.config.isBrandRS ? 'FBT' : null}
                launchViaTitleText={global.config.isBrandRS}
                text="Fringe Benefits Tax As your novated lease is a benefit your employer provides outside of your salary or wages, it’s subject to FBT. You may be able to offset any FBT liability by using the Employee Contribution Method."
                id="summarysection.fbttooltip"
              />
            </S.CardText>
            <S.CardValue xs={4} className="px-0" id="summarysection.fbt">
              {formatCurrency(fbt)}
            </S.CardValue>
          </Row>
        )}

        <Row className="mx-0 mr-md-3">
          <Col xs={8} md={{ offset: 2 }} className="px-0">
            <div className="d-flex ">
              {global.config.isBrandMX && (
                <>
                  <span className="mr-2">Tax and medicare deduction</span>
                  <Tooltip
                    header="Tax and medicare deduction"
                    text="A combined deduction of your estimated income tax and resulting Medicare levy. This deduction is collected by your employer."
                    id="summarysection.taxmedicare"
                  />
                </>
              )}
              {global.config.isBrandRS && (
                <S.BrandDefaultText className="mr-2">
                  <Tooltip
                    header="Tax and medicare"
                    headerText="Tax and medicare deduction"
                    launchViaTitleText={true}
                    text="A combined deduction of your estimated income tax and resulting Medicare levy. This deduction is collected by your employer."
                    id="summarysection.taxmedicare"
                  />{' '}
                  deduction
                </S.BrandDefaultText>
              )}
            </div>
          </Col>
          <S.CardValue xs={4} className="px-0" id="summarysection.taxmedicare">
            {formatCurrency(taxMedicare)}
          </S.CardValue>
        </Row>

        <Row className="mx-0 mr-md-3">
          <Col
            xs={8}
            md={{ offset: 2 }}
            className="px-0 border-top font-weight-bold pt-2"
          >
            {global.config.isBrandMX && (
              <>
                <span className="mr-2">Resulting net income</span>

                <Tooltip
                  header="Resulting net income"
                  text="Your income once all of your deductions (like income tax, superannuation & other salary packaging items) have been taken."
                  id="summarysection.netincometooltip"
                />
              </>
            )}
            {global.config.isBrandRS && (
              <S.BrandDefaultText>
                <Tooltip
                  header="Resulting net income"
                  headerText="Resulting net income"
                  text="Your income once all of your deductions (like income tax, superannuation & other salary packaging items) have been taken."
                  id="summarysection.netincometooltip"
                  launchViaTitleText={true}
                />
              </S.BrandDefaultText>
            )}
          </Col>

          <S.CardValue
            xs={4}
            className="pt-2 px-0 border-top"
            id="summarysection.netincome"
            bold={global.config.isBrandMX}
          >
            {formatCurrency(netIncome)}
          </S.CardValue>
        </Row>
      </div>

      <Row className="mx-0 mr-md-3 mt-4">
        <S.CardText xs={12} md={2} bold className="px-0">
          POST-TAX
        </S.CardText>

        <Col xs={6} md={8} className="px-0">
          {global.config.isBrandMX && (
            <>
              <span className="mr-2">
                Post-tax novated lease deduction (ECM)
              </span>

              <Tooltip
                header="Post-tax novated lease deduction (ECM)"
                text="We’ll deduct your payments from your salary before and after it gets taxed (your gross income, and your resulting net income). These post-tax deductions could free up money you're currently paying in income tax (and the Medicare levy), which we then put straight towards your lease. This method is called the Employee Contribution Method (ECM)."
                id="summarysection.posttaxdeductiontooltip"
              />
            </>
          )}
          {global.config.isBrandRS && (
            <S.BrandDefaultText>
              <Tooltip
                header="Post-tax"
                headerText="Post-tax novated lease deduction (ECM)"
                text="We’ll deduct your payments from your salary before and after it gets taxed (your gross income, and your resulting net income). These post-tax deductions could free up money you're currently paying in income tax (and the Medicare levy), which we then put straight towards your lease. This method is called the Employee Contribution Method (ECM)."
                id="summarysection.posttaxdeductiontooltip"
                launchViaTitleText={true}
              />{' '}
              novated lease deduction (ECM)
            </S.BrandDefaultText>
          )}
        </Col>

        <S.CardValue
          xs={6}
          md={2}
          className="px-0"
          id="summarysection.posttaxdeduction"
        >
          {formatCurrency(postTax)}
        </S.CardValue>
      </Row>
      {otherPostTax > 0 && (
        <Row className="mx-0 mr-md-3">
          <S.CardText xs={8} md={{ offset: 2 }} className="px-0">
            Other salary packaging items
          </S.CardText>
          <S.CardValue xs={4} className="px-0" id="summarysection.otherposttax">
            {formatCurrency(otherPostTax)}
          </S.CardValue>
        </Row>
      )}
      <Row className="border-top mx-0 pt-2 mt-3">
        <Col xs={8} md={{ offset: 2 }} className="px-0 font-weight-bold">
          {global.config.isBrandMX && (
            <>
              <span className="mr-2 font-weight-bold">
                Resulting take home pay
              </span>

              <Tooltip
                header="Resulting take home pay"
                text="The income you get to take home after tax and your novated leasing or salary package deductions. This amount doesn’t take into account any HECS/HELP repayments you might have."
                id="summarysection.takehomepaytooltip"
              />
            </>
          )}
          {global.config.isBrandRS && (
            <S.BrandDefaultText>
              <Tooltip
                header="Resulting take home pay"
                headerText="Resulting take home pay"
                launchViaTitleText={global.config.isBrandRS}
                text="The income you get to take home after tax and your novated leasing or salary package deductions. This amount doesn’t take into account any HECS/HELP repayments you might have."
                id="summarysection.takehomepaytooltip"
              />
            </S.BrandDefaultText>
          )}
        </Col>
        <S.CardValue
          xs={4}
          className="text-right px-0 pr-md-3"
          id="summarysection.takehomepay"
          bold={global.config.isBrandMX}
        >
          {formatCurrency(takeHome)}
        </S.CardValue>
      </Row>
    </>
  )
}

const SummarySection = (
  {
    data: {
      year,
      make,
      family,
      leaseTermYears,
      leaseTerm,
      payFrequency,
      annualRate,
      carRepaymentPerPay,
      totalPackagePerPay,
      runningCostsPerPay,
      savingsPerPay,
      outOfPocketPerPay,
      brand,
      fuelBudget,
      electricityBudget,
      tyresBudget,
      incidentalsBudget,
      registrationBudget,
      scheduleMaintenanceBudget,
      roadsideAssistanceBudget,
      roadsideAssist,
      compInsRenewalBudget,
      takeHomePerPay,
      grossSalaryPerPay,
      grossAnnualSalary,
      preTaxPerPay,
      spPreTaxDeduction,
      otherPreTaxPerPay,
      preTaxDeduction,
      taxSharePerPay,
      spTaxShareDeduction,
      netSalaryPerPay,
      netSalaryPerAnnum,
      taxMedicarePerPay,
      spTaxAndMedicare,
      netIncomePerPay,
      spNetCashSalary,
      postTaxPerPay,
      specm,
      otherPostTaxPerPay,
      postTaxDeduction,
      spCashinhand,
      lifeOfLeaseTaxSaving,
      leaseResidualAmountIncGST,
      userFirstName,
      consultantFirstName,
      vehicleDescription,
      opportunityId,
      vehicleId,
      gstSavingsOnRunningCosts,
      displayInterest,
      fbtPerPay,
      fbtPerAnnum,
      productId,
      fbtMethod,
      vehicleFBTValue,
      overTheCapMethod,
      employerName,
      totalSavingsITCsTaxVehicleGST,
      taxandMedicareSavingsLifeofLease,
      gstSavingsOnRunningCostsLifeofLease,
      gstCreditClaimable
    },
    applicationRole,
    expandAccordion,
  },
  props
) => {
  const isDownloadingPdf = useSelector(
    (state) => state.downloadPdf.isDownloading
  )

  const resolutionBreakpoint = {
    nonDesktop: getCurrentResolutionBreakPoint(isDownloadingPdf),
  }

  const [width] = useWindowSize()
  let isDesktop = width >= resolutionBreakpoint.nonDesktop

  const ScrollToEndOfLeaseSection = () => {
    document
      .getElementById('endOfLeaseSection')
      .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
  }

  let leaseTermTxt =
    leaseTerm % 12 === 0 ? leaseTermYears + ' Years' : leaseTerm + ' Months'

  let isSAGBYO = IsSpecialEmployer('SAGBYO')

  let GetFBTValuationText = () => {
    if (
      (fbtMethod && fbtMethod.toLowerCase() === 'ecm') ||
      (fbtMethod &&
        fbtMethod.toLowerCase().includes('cap') &&
        postTaxPerPay &&
        postTaxPerPay > 0)
    ) {
      return (
        ' Post-tax novated lease deduction (ECM) is calculated using an FBT Base value of ' +
        formatCurrency(vehicleFBTValue) +
        '.'
      )
    } else if (fbtMethod && fbtMethod.toLowerCase() === 'fbt') {
      return (
        ' FBT is calculated using an FBT Base value of ' +
        formatCurrency(vehicleFBTValue) +
        '.'
      )
    } else {
      return ''
    }
  }

  let fbtValuationText = GetFBTValuationText()

  let nswhnFBTText = null
  let isNSWHN = IsSpecialEmployer('NSWHN')
  if (isNSWHN) {
    const specialEmployerNameList = [
      'DHNSW',
      'HNHSS',
      'CINSW',
      'HNHET',
      'NSW Ministry of Health',
      'Health System Support Group',
      'Cancer Institute NSW',
      'Health Education and Training Institute',
    ] //different text for employers whose name starts with any of these
    var result = specialEmployerNameList.filter((option) =>
      employerName.startsWith(option)
    )
    let specialEmployer = result.length !== 0

    if (fbtMethod === 'ECM')
      nswhnFBTText =
        'This Estimate is structured using the Employee Contribution Method (ECM), based on 20% statutory percentage.' +
        (specialEmployer
          ? ''
          : ' This is on top of your current capping limit of $9,010.')
    else if (fbtMethod === 'FBT')
      nswhnFBTText = specialEmployer
        ? null
        : 'This Estimate assumes that you are exempt from Fringe Benefits Tax and you are entitled to a capping limit of $9,010. It is structured to include all or part of your novated lease running costs within your capping limit.'
    else if (fbtMethod && fbtMethod.toLowerCase().includes('cap'))
      nswhnFBTText = specialEmployer
        ? null
        : 'This Estimate assumes that you are exempt from Fringe Benefits Tax and you are entitled to a capping limit of $9010.00. It is structured to include all or part novated lease and running costs within your capping limit.'
  }
  let haveNewTaxSavings = totalSavingsITCsTaxVehicleGST > 0
  let lifeOfLeaseSaving = haveNewTaxSavings ? totalSavingsITCsTaxVehicleGST : lifeOfLeaseTaxSaving

  return (
    <div>
      <Container
        fluid
        className="bg-shape container-summary print-page-break-before"
      >
        <Container className="section">
          <S.StyledH3 className="mb-4">
            First up, your {global.config.isBrandMX ? 'novated' : ''} lease
            summary
          </S.StyledH3>
          <S.BrandDefaultText id="summarysection.vehicledesc" className="mb-3">
            Let's breakdown what your novated lease would look like if you
            unlocked the
            {vehicleId && (
              <>
                {' '}
                {year} {make} {family}{' '}
              </>
            )}
            {!vehicleId && <> {vehicleDescription} </>}
            on a {leaseTermTxt} lease.
          </S.BrandDefaultText>
          <S.SubHeadingDiv className="mb-2">
            Your chosen novated lease term
          </S.SubHeadingDiv>
          <S.BrandDefaultText
            className="mb-4"
            id="summarysection.leasetermtext"
          >
            Your lease term is still flexible {userFirstName}, and designed to
            reflect how long you’d like to keep your car. Adjusting this term
            will adjust the amount you pay {toLowerCase(payFrequency)}, as well
            as your residual at the end of your lease.
          </S.BrandDefaultText>
          <LeaseTerm months={leaseTerm} />
          <br></br>
          <S.BrandDefaultText className="mb-4">
            Want to update this term before you take out your lease? Can do.
            {applicationRole &&
              applicationRole !== applicationRoles.CONSULTANT && (
                <>
                  <ContactUsDialog
                    className={
                      global.config.isBrandMX ? 'link' : 'link text-underline'
                    }
                    theme="link"
                    launchText="Simply contact your consultant"
                    id="summarysection.contactus1"
                  />{' '}
                </>
              )}
            {applicationRole &&
              applicationRole === applicationRoles.CONSULTANT && (
                <>
                  <a
                    className="link text-underline readonly"
                    theme="link"
                    id="summarysection.contactus1readonly"
                  >
                    Simply contact your consultant
                  </a>{' '}
                </>
              )}
            for help.
          </S.BrandDefaultText>

          {productId && (
            <div>
              <S.SubHeadingDiv className="mb-2">
                Your chosen lease product type
              </S.SubHeadingDiv>
              <S.BrandDefaultText
                id="summarysection.productid"
                className="mb-3"
              >
                {capitalizeEachFirstLetter(
                  productId.toLowerCase().replace('novated lease', '').trim()
                )}
              </S.BrandDefaultText>
            </div>
          )}
        </Container>

        <Container className="section-summary mb-24">
          <Card className="mb-24 card-shadow">
            <Card.Body className="card-body--summary">
              <Row className="your-boxes mb-5">
                <Col xs={12} md={4}>
                  <E.GreenH5 className="mb-2">Your total package</E.GreenH5>
                  <E.GreenCard smaller pale>
                    <div>Car finance</div>
                    <E.PlusSignDiv>+</E.PlusSignDiv>
                    <div>{EstimateDetailStaticData('TotalPackageLine2')}</div>
                  </E.GreenCard>
                  <E.CardDetails>
                    <strong>Over life of lease</strong>
                    <br />
                    Making your experience on the road smoother with support
                    from the {brand} team
                  </E.CardDetails>
                </Col>
                <Col xs={12} md={4}>
                  <E.GreenH5 className="mb-2">Potential tax benefits</E.GreenH5>
                  <E.GreenCard white>
                    <div id="summarysection.savingsperpay">
                      {formatCurrency(savingsPerPay)}
                    </div>
                  </E.GreenCard>
                  <E.CardDetails>
                    <strong id="summarysection.payfrequency1">
                      {capitalizeOnlyFirstLetter(payFrequency)}
                    </strong>
                    <br />
                    Access ongoing tax benefits, exclusive to novated leasing
                  </E.CardDetails>
                </Col>
                <Col xs={12} md={4}>
                  <E.GreenH5 className="mb-2">
                    Estimated out of pocket
                  </E.GreenH5>
                  <E.GreenCard dark>
                    <div id="summarysection.outofpocketperpay">
                      {formatCurrency(outOfPocketPerPay)}
                    </div>
                  </E.GreenCard>
                  <E.CardDetails>
                    <strong id="summarysection.payfrequency2">
                      {capitalizeOnlyFirstLetter(payFrequency)}
                    </strong>
                    <br />
                    To try and keep your out of pocket cost lower than your
                    total deductions, we put these benefits straight towards
                    your package.
                  </E.CardDetails>
                </Col>
              </Row>

              {/* What we'll deduct each fortnight: Start */}

              <Card className="mb-24 ">
                <Card.Header className="border-bottom-0 d-flex justify-content-between">
                  <S.CardHeader id="summarysection.payfrequency3">
                    Your estimated total {toLowerCase(payFrequency)} deductions
                  </S.CardHeader>
                  <S.CardHeaderValue id="summarysection.totalpackageperpay1">
                    {formatCurrency(totalPackagePerPay)}
                  </S.CardHeaderValue>
                </Card.Header>
                <Card.Body>
                  <AccordionSection
                    readerText={`Your estimated total ${toLowerCase(
                      payFrequency
                    )} deductions`}
                    expandAccordion={expandAccordion}
                    title={EstimateDetailStaticData('EverythingAccordion')}
                    id="summarysection.everythingaccordion"
                  >
                    <>
                      <S.BrandDefaultText className="font-weight-bold mb-3">
                        Why your package is more valuable than the car
                      </S.BrandDefaultText>
                      <S.GreyTextDiv className="ml-0 mb-3">
                        Your running costs, finance arrangement and the car
                        itself are all packaged up for you in your deductions.
                        Meaning you can hit the road with the peace of mind a
                        convenient budget brings. Plus, with the ease of novated
                        leasing, you'll enjoy a smoother on road experience.{' '}
                      </S.GreyTextDiv>
                      <S.BrandDefaultText className="font-weight-bold mb-3">
                        Your total package
                      </S.BrandDefaultText>
                      <Row>
                        <S.CardText
                          xs={7}
                          md={9}
                          id="summarysection.annualrate"
                        >
                          {displayInterest
                            ? `Car lease payments (includes ${annualRate}% interest)`
                            : `Car lease payments`}
                        </S.CardText>
                        <S.CardValue
                          xs={5}
                          md={3}
                          id="summarysection.repaymentperpay"
                        >
                          {formatCurrency(carRepaymentPerPay)}
                        </S.CardValue>
                      </Row>
                      <Row>
                        <S.CardText>
                          {EstimateDetailStaticData('TotalPackageOngoing')}
                        </S.CardText>
                        <S.CardValue id="summarysection.ongoingrunning">
                          {formatCurrency(runningCostsPerPay - fbtPerPay)}
                        </S.CardValue>
                      </Row>
                      {fbtPerPay > 0 && (
                        <Row>
                          <S.CardText>FBT</S.CardText>
                          <S.CardValue id="summarysection.fbtperpay">
                            {formatCurrency(fbtPerPay)}
                          </S.CardValue>
                        </Row>
                      )}
                      <Row>
                        {!!fuelBudget && (
                          <Col xs={12} md={6} className="mb-12">
                            {global.config.isBrandMX && (
                              <MaxxiaIcon 
                                iconType="Fuel" 
                                id={`summary-fuel`} />
                            )}
                            {global.config.isBrandRS && (
                              <RemServIcon
                                iconType="Fuel"
                                id={`summary-fuel`}
                              />
                            )}
                            <E.IconText id="summarysection.fuelicon">
                              Fuel
                            </E.IconText>
                          </Col>
                        )}

                        {!!electricityBudget && (
                          <Col xs={12} md={6} className="mb-12">
                            {global.config.isBrandMX && (
                              <MaxxiaIcon
                                iconType="Electricity"
                                id={`summary-electricity`}
                              />
                            )}
                            {global.config.isBrandRS && (
                              <RemServIcon
                                iconType="Electricity"
                                id={`summary-electricity`}
                              />
                            )}
                            <E.IconText id="summarysection.electricicon">
                              Electricity
                            </E.IconText>
                          </Col>
                        )}

                        {!!scheduleMaintenanceBudget && (
                          <Col xs={12} md={6} className="mb-12">
                            {global.config.isBrandMX && (
                              <MaxxiaIcon
                                iconType="ScheduledMaintenance"
                                id={`summary-scheduled-maintenance`}
                              />
                            )}
                            {global.config.isBrandRS && (
                              <RemServIcon
                                iconType="ScheduledMaintenance"
                                id={`summary-scheduled-maintenance`}
                                size={1.4}
                                primary
                              />
                            )}
                            <E.IconText id="summarysection.servicingicon">
                              Scheduled servicing
                            </E.IconText>
                          </Col>
                        )}
                        {!!tyresBudget && (
                          <Col xs={12} md={6} className="mb-12">
                            {global.config.isBrandMX && (
                              <MaxxiaIcon
                                iconType="Tyres"
                                id={`summary-replacement-tyres`}
                              />
                            )}
                            {global.config.isBrandRS && (
                              <RemServIcon
                                iconType="ReplacementTyres"
                                id={`summary-replacement-tyres`}
                              />
                            )}
                            <E.IconText id="summarysection.tyresicon">
                              Replacement tyres
                            </E.IconText>
                          </Col>
                        )}
                        {(!!roadsideAssistanceBudget || roadsideAssist) && (
                          <Col xs={12} md={6} className="mb-12">
                            {global.config.isBrandMX && (
                              <MaxxiaIcon
                                iconType="RoadsideAssistance"
                                id={`summary-roadside`}
                              />
                            )}
                            {global.config.isBrandRS && (
                              <RemServIcon
                                iconType="RoadsideAssistance"
                                id={`summary-roadside`}
                              />
                            )}
                            <E.IconText id="summarysection.roadsideicon">
                              Roadside assistance
                            </E.IconText>
                          </Col>
                        )}
                        {!!incidentalsBudget && (
                          <Col xs={12} md={6} className="mb-12">
                            {global.config.isBrandMX && (
                              <MaxxiaIcon
                                iconType="Incidentals"
                                id={`summary-incidentals`}
                              />
                            )}
                            {global.config.isBrandRS && (
                              <RemServIcon
                                iconType="Incidentals"
                                id={`summary-incidentals`}
                              />
                            )}
                            <E.IconText id="summarysection.incidentalsicon">
                              Incidentals
                            </E.IconText>
                          </Col>
                        )}
                        {!!compInsRenewalBudget && (
                          <Col xs={12} md={6} className="mb-12">
                            {global.config.isBrandMX && (
                              <MaxxiaIcon
                                iconType="Insurance"
                                id={`summary-comprehensive-insurance`}
                              />
                            )}
                            {global.config.isBrandRS && (
                              <RemServIcon
                                iconType="ComprehensiveInsurance"
                                id={`summary-comprehensive-insurance`}
                                size={1.4}
                              />
                            )}
                            <E.IconText id="summarysection.compinsuranceicon">
                              Comprehensive insurance
                            </E.IconText>
                          </Col>
                        )}
                        {!!registrationBudget && (
                          <Col xs={12} md={6} className="mb-12">
                            {global.config.isBrandMX && (
                              <MaxxiaIcon
                                iconType="Registration"
                                id={`summary-annual-registration`}
                              />
                            )}
                            {global.config.isBrandRS && (
                              <RemServIcon
                                iconType="Registration"
                                id={`summary-annual-registration`}
                                size={1.4}
                              />
                            )}
                            <E.IconText id="summarysection.registrationicon">
                              Annual registration
                            </E.IconText>
                          </Col>
                        )}

                        {fbtPerPay > 0 && (
                          <Col xs={12} md={6} className="mb-12">
                            <Icons.LeaseFees id="summary-fbt" />
                            <E.IconText id="summarysection.fbticon">
                              FBT
                            </E.IconText>
                          </Col>
                        )}
                      </Row>
                      <Row className="text-right font-weight-bold border-top mx-0 pt-2 mt-3">
                        <S.CardText bold xs md={9} className="px-0">
                          Total package deduction
                        </S.CardText>
                        <S.CardValue
                          bold
                          xs
                          md={3}
                          className="px-0"
                          id="summarysection.totalpackageperpay2"
                        >
                          {formatCurrency(totalPackagePerPay)}
                        </S.CardValue>
                      </Row>
                    </>
                  </AccordionSection>
                </Card.Body>
              </Card>
              {/* What we'll deduct each fortnight: End */}

              {/* How we help you do more with your salary: Start */}
              <Card className="mb-24">
                <Card.Header className="border-bottom-0 d-flex justify-content-between">
                  <S.CardHeader>Your Resulting take home pay</S.CardHeader>
                  <S.CardHeaderValue id="summarysection.takehomepayperpay">
                    {formatCurrency(takeHomePerPay)}
                  </S.CardHeaderValue>
                </Card.Header>
                <Card.Body>
                  <AccordionSection
                    readerText="Your resulting take home pay"
                    expandAccordion={expandAccordion}
                    title="Unpack how your chosen leasing method is estimated to affect your take home pay."
                    id="summarysection.leasingmethodaccordion"
                  >
                    <>
                      {!isSAGBYO && (
                        <p>
                          We'll deduct your payments from your salary before and
                          after it gets taxed (your gross income, and your
                          resulting net income). These pre-tax deductions could
                          free up money you're currently paying in income tax
                          (and the{' '}
                          <Tooltip
                            header="Medicare levy"
                            launchViaTitleText="true"
                            text="The Medicare levy is 2% of your taxable income, in addition to the tax you pay on your taxable income. It’s used to help fund some of the costs of Australia's public health system known as Medicare."
                            id="summarysection.medicarelevytooltip"
                          />
                          ), which we then put straight towards your lease.
                        </p>
                      )}

                      {nswhnFBTText !== null ? (
                        <E.FBTDiv id="runningsection.nswfbt">
                          {nswhnFBTText}
                        </E.FBTDiv>
                      ) : (
                        <></>
                      )}

                      <S.BrandDefaultText
                        style={{
                          fontWeight: global.config.isBrandRS
                            ? 'bold'
                            : 'normal',
                          marginBottom: '12px',
                        }}
                      >
                        Here are the numbers:
                      </S.BrandDefaultText>

                      <Tabs
                        id="summarysection.takehomepaytab"
                        data={[
                          {
                            title: payFrequency,
                            content: () => (
                              <TakeHomePayTable
                                grossSalary={grossSalaryPerPay}
                                preTaxDeduction={preTaxPerPay}
                                otherPreTax={otherPreTaxPerPay}
                                taxShare={taxSharePerPay}
                                netSalary={netSalaryPerPay}
                                taxMedicare={taxMedicarePerPay}
                                netIncome={netIncomePerPay}
                                postTax={postTaxPerPay}
                                otherPostTax={otherPostTaxPerPay}
                                takeHome={takeHomePerPay}
                                fbt={fbtPerPay}
                                fbtMethod={fbtMethod}
                                overTheCapMethod={overTheCapMethod}
                                isNSWHN={isNSWHN}
                              />
                            ),
                            id: 'summarysection.takehometablepayfreq',
                          },
                          {
                            title: 'Annually',
                            content: () => (
                              <TakeHomePayTable
                                grossSalary={grossAnnualSalary}
                                preTaxDeduction={spPreTaxDeduction}
                                otherPreTax={preTaxDeduction}
                                taxShare={spTaxShareDeduction}
                                netSalary={netSalaryPerAnnum}
                                taxMedicare={spTaxAndMedicare}
                                netIncome={spNetCashSalary}
                                postTax={specm}
                                otherPostTax={postTaxDeduction}
                                takeHome={spCashinhand}
                                fbt={fbtPerAnnum}
                                fbtMethod={fbtMethod}
                                overTheCapMethod={overTheCapMethod}
                                isNSWHN={isNSWHN}
                              />
                            ),
                            id: 'summarysection.takehometableannual',
                          },
                        ]}
                        activeIndex={0}
                        equalWidth
                        theme={
                          global.config.isBrandMX ? MaxxiaTheme : RemServTheme
                        }
                      />
                      <p className="my-4 text-small">
                        Disclaimer: The pre-tax salary in the calculations is
                        net of your employer’s compulsory superannuation
                        guarantee contribution. The Tax and Medicare
                        calculations do not take into account any HECS/HELP
                        repayments that may apply to your personal financial
                        circumstances.
                        {fbtValuationText && (
                          <span
                            className="font-weight-bold"
                            id="summarysection.fbtvaluation"
                          >
                            {fbtValuationText}
                          </span>
                        )}
                      </p>
                      <p className="font-weight-bold text-brand mb-2">
                        Want a second opinion from someone you trust?
                      </p>
                      <p className="mb-4" id="summarysection.consultfirstname">
                        {consultantFirstName} is here to explain the ins and
                        outs of your estimate to the people you turn to when
                        making decisions.
                      </p>
                      {applicationRole &&
                        applicationRole !== applicationRoles.CONSULTANT &&
                        global.config.isBrandMX && (
                          <ContactUsDialog
                            variant="invertColor"
                            invertColor
                            extendInMob
                            className="mb-4"
                            theme="button"
                            size="sm"
                            launchText="Get help explaining my estimate"
                            id="summarysection.contactus2"
                          />
                        )}
                      {applicationRole &&
                        applicationRole !== applicationRoles.CONSULTANT &&
                        global.config.isBrandRS && (
                          <ContactUsDialog
                            className="link font-weight-bold text-underline text-dark"
                            theme="link"
                            launchText="Contact my consultant"
                            inlineText
                          />
                        )}
                      {applicationRole &&
                        applicationRole === applicationRoles.CONSULTANT &&
                        global.config.isBrandMX && (
                          <PrimaryButton
                            variant="invertColor"
                            size="sm"
                            className="mb-4 readonly btn-sm"
                            extendInMob
                            id="summarysection.contactus2readonly"
                          >
                            Get help explaining my estimate
                          </PrimaryButton>
                        )}
                    </>
                  </AccordionSection>
                </Card.Body>
              </Card>
              {/* How we help you do more with your salary: End */}
              
              <Card className="mb-24">
                <Card.Body className="border-bottom-0">
                  {isDesktop && (
                    <div>
                      <Row>
                        <S.GreyTextDiv
                          xs={7}
                          md={9}
                          bold={global.config.isBrandMX}
                          smallerText={global.config.isBrandRS}
                        >
                          Your estimated life of lease savings
                        </S.GreyTextDiv>
                        <S.CardValue bold id="summarysection.lifeofleasetaxsave">
                          {formatCurrency(lifeOfLeaseSaving)}
                        </S.CardValue>  
                      </Row>
                      {haveNewTaxSavings  && 
                        <div>
                          <Row className="mt-3">
                        <S.GreyTextDiv
                            xs={7}
                            md={9}
                            smallerText
                          >
                            How are the estimated life of lease savings calculated?
                          </S.GreyTextDiv>
                        </Row>
                        {taxandMedicareSavingsLifeofLease > 0  &&
                          <Row className="mt-2">
                            <S.GreyTextDiv
                              xs={7}
                              md={9}
                              smallerText
                            >
                              Estimated Tax and Medicare Levy Savings
                            </S.GreyTextDiv>
                            <S.CardValue smallerText id="summarysection.taxandmedicaresavings">
                              {formatCurrency(taxandMedicareSavingsLifeofLease)}
                            </S.CardValue> 
                          </Row>
                        }
                        {gstSavingsOnRunningCostsLifeofLease > 0  && 
                          <Row>
                            <S.GreyTextDiv
                              xs={7}
                              md={9}
                              smallerText
                            >
                               Estimated GST Saving on Running Cost
                            </S.GreyTextDiv>
                            <S.CardValue smallerText id="summarysection.gstsavingonrunningcosts">
                              {formatCurrency(gstSavingsOnRunningCostsLifeofLease)}
                            </S.CardValue> 
                          </Row>
                        }
                        {gstCreditClaimable > 0 && 
                          <Row>
                            <S.GreyTextDiv
                              xs={7}
                              md={9}
                              smallerText
                            >
                              Estimated GST Saving on Purchase Price
                            </S.GreyTextDiv>
                            <S.CardValue smallerText id="summarysection.gstonpurchaseprice">
                              {formatCurrency(gstCreditClaimable)}
                            </S.CardValue> 
                          </Row>
                        }
                      </div>
                    }
                    </div>
                  )}
                  {!isDesktop && (
                    <div>
                      <Row>
                        <S.GreyTextDiv
                          xs={7}
                          md={9}
                          bold={global.config.isBrandMX}
                          smallerText={global.config.isBrandRS}
                        >
                          Your estimated life of lease savings
                        </S.GreyTextDiv>
                      </Row>
                      <Row>
                        <S.CardValue
                          bold
                          leftValue
                          id="summarysection.lifeofleasetaxsave"
                        >
                          {formatCurrency(lifeOfLeaseSaving)}
                        </S.CardValue>
                      </Row>
                      {haveNewTaxSavings && <div>
                        <Row className="mt-3 mb-2">
                          <S.GreyTextDiv
                            xs={7}
                            md={9}
                            smallerText
                          >
                            How are estimated life of lease savings calculated?
                          </S.GreyTextDiv>
                        </Row>
                        { taxandMedicareSavingsLifeofLease> 0  &&
                          <Row>
                            <S.GreyTextDiv
                              xs={7}
                              md={9}
                              smallerText
                            >
                              Estimated Tax and Medicare Levy Savings
                            </S.GreyTextDiv>
                            <S.CardValue
                              leftValue
                              id="summarysection.taxandmedicarelevysavingsmob"
                            >
                              {formatCurrency(taxandMedicareSavingsLifeofLease)}
                            </S.CardValue>
                          </Row>
                        }
                        {gstSavingsOnRunningCostsLifeofLease > 0 && 
                          <Row>
                            <S.GreyTextDiv
                              xs={7}
                              md={9}
                              smallerText
                            >
                              GST Saving on Running Cost
                            </S.GreyTextDiv>
                            <S.CardValue
                              leftValue
                              id="summarysection.gstsavingrunningcostmob"
                            >
                              {formatCurrency(gstSavingsOnRunningCostsLifeofLease)}
                            </S.CardValue>
                          </Row>
                        }
                        <Row>
                          <S.GreyTextDiv
                            xs={7}
                            md={9}
                            smallerText
                          >
                            GST Saving on Purchase Price
                          </S.GreyTextDiv>
                          <S.CardValue
                            leftValue
                            id="summarysection.gstcreditpurchasemob"
                          >
                            {formatCurrency(gstCreditClaimable)}
                          </S.CardValue>
                        </Row>
                      </div>}
                    </div>
                  )}
                </Card.Body>
              </Card>
              <Card>
                <Card.Body className="border-bottom-0">
                  {isDesktop && (
                    <Row>
                      <S.GreyTextDiv
                        xs={7}
                        md={9}
                        onClick={ScrollToEndOfLeaseSection}
                        className="clickable"
                        bold={global.config.isBrandMX}
                        smallerText={global.config.isBrandRS}
                      >
                        Your total residual value (after lease term)
                      </S.GreyTextDiv>
                      <S.CardValue bold id="summarysection.leaseresidual">
                        {formatCurrency(leaseResidualAmountIncGST)}
                      </S.CardValue>
                    </Row>
                  )}
                  {!isDesktop && (
                    <div>
                      <Row>
                        <S.GreyTextDiv
                          xs={7}
                          md={9}
                          onClick={ScrollToEndOfLeaseSection}
                          className="clickable"
                          bold={global.config.isBrandMX}
                          smallerText={global.config.isBrandRS}
                        >
                          Your total residual value (after lease term)
                        </S.GreyTextDiv>
                      </Row>
                      <Row>
                        <S.CardValue
                          bold
                          leftValue
                          id="summarysection.leaseresidual"
                        >
                          {formatCurrency(leaseResidualAmountIncGST)}
                        </S.CardValue>
                      </Row>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Card.Body>
          </Card>
        </Container>
        <Container className="section mb-2 print-page-break-before">
          <AccordionCard
            expandAccordion={expandAccordion}
            title="Can I pay out my lease early?"
            id="summarysection.payearlyaccordion"
            className="card-shadow"
            smallerTitleText={global.config.isBrandRS}
          >
            <S.BrandDefaultText>
              <div>
                Yep, you can pay out your lease early and exit at any time.
                Generally speaking, we wouldn't recommend going down that path.
                If you do decide to, here are your options:
              </div>
              <br />
              <div>
                1. Buy the car outright, paying out whatever's owing on your
                lease, plus your residual.
                {global.config.isBrandRS && <br />}
                <br />
                2. Return the car, paying out whatever's owing on your lease.
              </div>
              <br />
              <div>
                Keep in mind whichever option you choose, you'll be paying back
                your lease in its entirety. e.g. If you want to exit a five year
                lease after only four years, you'll still have to pay out the
                full five years. And depending on how far into your lease you
                are, the car might not be worth as much as the amount you need
                to pay out.
              </div>
            </S.BrandDefaultText>
          </AccordionCard>
        </Container>
        <Container className="section mb-4">
          <AccordionCard
            expandAccordion={expandAccordion}
            title="What if I leave my current job?"
            id="summarysection.leavejobaccordion"
            className="card-shadow"
            smallerTitleText={global.config.isBrandRS}
          >
            <S.BrandDefaultText>
              <div>
                You’ve always got options if you leave your current job.
              </div>
              <br />
              <div>
                1. Buy the car outright, paying out whatever's owing on your
                lease, plus your residual.
                <br />
                {global.config.isBrandRS && <br />}
                2. Keep paying for your lease yourself, with regular post-tax
                dollars. <br />
                {global.config.isBrandRS && <br />}
                3. Transfer your lease to your new employer, subject to their
                approval.
                <br />
              </div>
              <br />
              {!isSAGBYO && (
                <div>
                  Taking out add-on Lease Protection Insurance can provide some
                  security in case you’re made involuntarily redundant. If this
                  policy is right for you, you’ll need to take it out before
                  your lease begins
                </div>
              )}
            </S.BrandDefaultText>
          </AccordionCard>
        </Container>
      </Container>
    </div>
  )
}

export default SummarySection
